import React from "react";
import ChecklistItem from "./ChecklistItem";

export default function DoneChecklistItems(props) {
  const {
    doneIds,
    patchChecklistItem,
    sortItemToDoneList,
    undoneIds,
    entities,
  } = props;
  return (
    <>
      {doneIds.map((id, i) => {
        const item = entities[id];
        return (
          <ChecklistItem
            done={true}
            key={item.id}
            ciIndex={i}
            hasBreak={i > 0 || undoneIds.length !== 0}
            {...item}
            {...{ patchChecklistItem, sortItemToDoneList }}
          />
        );
      })}
    </>
  );
}
